import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { alcoholMandatoryCounselingAddressNameFields } from 'constants/enums/people';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import substanceAlcoholOrderedCounselingItemValidator from './validators/item';
import { SubstanceAlcoholOrderedCounselingModel } from './types';

const substanceAlcoholOrderedCounselingValidator: ValidateJSModel<SubstanceAlcoholOrderedCounselingModel> = {
  HasBeenOrdered: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes, attributeName, options) => {
    if (attributes?.HasBeenOrdered && attributes?.HasBeenOrdered.value === 'Yes') {
      let additionalValidation = {};
      const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options?.peopleWhoKnowYou, alcoholMandatoryCounselingAddressNameFields);
      if (errors.length > 0) {
        additionalValidation = {
          requireTrue: { // force error message; value will never be true
            message: 'relationships.people.error.duplicateListItems',
          }
        };
      }
      return {
        presence: true,
        ...additionalValidation,
        accordion: { validator: substanceAlcoholOrderedCounselingItemValidator },
      };
    }
    return {};
  },
  Comments: {},
  SummaryComments: {},
};

export default substanceAlcoholOrderedCounselingValidator;
